import { render, staticRenderFns } from "./_sendMsg.vue?vue&type=template&id=5f312a41&scoped=true"
import script from "./_sendMsg.vue?vue&type=script&lang=js"
export * from "./_sendMsg.vue?vue&type=script&lang=js"
import style0 from "./_sendMsg.vue?vue&type=style&index=0&id=5f312a41&prod&lang=scss&scoped=true"
import style1 from "./_sendMsg.vue?vue&type=style&index=1&id=5f312a41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f312a41",
  null
  
)

export default component.exports